import React, { useState } from 'react';
import { X, Keyboard } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const KeyboardShortcuts = () => {
    const [show, setShow] = useState(false);

    return (
        <>
            {/* Help Button */}
            {/* Help Button */}
            <motion.button
                onClick={() => setShow(true)}
                className="fixed bottom-10 left-10 z-20 w-12 h-12 rounded-full bg-cyan-500 backdrop-blur-xl flex items-center justify-center border border-cyan-400 shadow-lg hover:shadow-cyan-500/30 transition-all"
                whileHover={{ scale: 1.1, y: -4 }}
            >
                <Keyboard size={20} className="text-white" strokeWidth={1.5} />
            </motion.button>

            {/* Shortcuts Overlay */}
            <AnimatePresence>
                {show && (
                    <motion.div
                        className="fixed inset-0 bg-black/60 backdrop-blur-md z-50 flex items-center justify-center p-8"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={() => setShow(false)}
                    >
                        <motion.div
                            className="bg-white rounded-3xl p-12 max-w-2xl w-full relative"
                            initial={{ scale: 0.9, y: 20 }}
                            animate={{ scale: 1, y: 0 }}
                            exit={{ scale: 0.9, y: 20 }}
                            onClick={(e) => e.stopPropagation()}
                            style={{ boxShadow: '0 40px 100px -20px rgba(0, 0, 0, 0.5)' }}
                        >
                            <button
                                onClick={() => setShow(false)}
                                className="absolute top-6 right-6 w-10 h-10 rounded-full hover:bg-gray-100 flex items-center justify-center transition-colors"
                            >
                                <X size={20} className="text-gray-400" />
                            </button>

                            <h2 className="text-4xl font-light text-gray-900 mb-8">Keyboard Shortcuts</h2>

                            <div className="space-y-6">
                                <div>
                                    <h3 className="text-sm font-light text-gray-500 mb-3 uppercase tracking-wide">Swipe Actions</h3>
                                    <div className="space-y-2">
                                        <div className="flex items-center justify-between py-3 px-4 bg-gray-50 rounded-xl">
                                            <span className="text-gray-700 font-light">Pass (swipe left)</span>
                                            <kbd className="px-4 py-2 bg-white border border-gray-200 rounded-lg text-gray-900 font-mono text-sm shadow-sm">←</kbd>
                                        </div>
                                        <div className="flex items-center justify-between py-3 px-4 bg-gray-50 rounded-xl">
                                            <span className="text-gray-700 font-light">Add to Watchlist (swipe up)</span>
                                            <kbd className="px-4 py-2 bg-white border border-gray-200 rounded-lg text-gray-900 font-mono text-sm shadow-sm">↑</kbd>
                                        </div>
                                        <div className="flex items-center justify-between py-3 px-4 bg-gray-50 rounded-xl">
                                            <span className="text-gray-700 font-light">Add to Trade List (swipe right)</span>
                                            <kbd className="px-4 py-2 bg-white border border-gray-200 rounded-lg text-gray-900 font-mono text-sm shadow-sm">→</kbd>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <h3 className="text-sm font-light text-gray-500 mb-3 uppercase tracking-wide">Timeframe</h3>
                                    <div className="space-y-2">
                                        <div className="flex items-center justify-between py-3 px-4 bg-gray-50 rounded-xl">
                                            <span className="text-gray-700 font-light">Day view</span>
                                            <kbd className="px-4 py-2 bg-white border border-gray-200 rounded-lg text-gray-900 font-mono text-sm shadow-sm">D</kbd>
                                        </div>
                                        <div className="flex items-center justify-between py-3 px-4 bg-gray-50 rounded-xl">
                                            <span className="text-gray-700 font-light">Week view</span>
                                            <kbd className="px-4 py-2 bg-white border border-gray-200 rounded-lg text-gray-900 font-mono text-sm shadow-sm">W</kbd>
                                        </div>
                                        <div className="flex items-center justify-between py-3 px-4 bg-gray-50 rounded-xl">
                                            <span className="text-gray-700 font-light">Month view</span>
                                            <kbd className="px-4 py-2 bg-white border border-gray-200 rounded-lg text-gray-900 font-mono text-sm shadow-sm">M</kbd>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-8 pt-6 border-t border-gray-100 text-center">
                                <p className="text-sm text-gray-400 font-light">Press <kbd className="px-2 py-1 bg-gray-100 rounded text-xs">?</kbd> anytime to view shortcuts</p>
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
};

export default KeyboardShortcuts;
